import React, {Component} from "react";
import Script from "react-load-script";
import {map, isEmpty, forEach} from "lodash";
import {message, Select} from "antd";
import * as yup from "yup";
import moment from "moment-timezone";
import {PlusOutlined} from '@ant-design/icons';
import Loader from "../../../Common/Component/Loader";
import cross_icon from "../../../../Assets/images/cross_icon.svg";
import AllState from "../../../../Assets/data/stateList.json";
import { aboutUsData } from "../../../../Assets/data/aboutUsList";
import Axios from 'axios';
const {Option} = Select;
const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
class BasicDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      check_email: false,
      zipcodeCheck: null,
      zipcode: '',
      franchises: [],
      firstName: '',
      lastName: '',
      address: {address: '', city: '', state: '', zip_code: ''},
      phone_numbers: [],
      emails: [],
      authorizedUser: [],
      phone: '',
      phone_type: 'mobile',
      can_send_sms: false,
      hear_about_us: '',
      email: '',
      username: '',
      leadData: {},
      isLocalValueChanged: false,
      isLeadDetail: false,
      loader: false,
      is_address_manually: false,
      outreach: '',
      field_office_uuid: ''
    }
  }

  componentDidMount = () => {
    const {customerId, currentTab, isBackClick} = this.props;

    this.setState({loader: true});

    // get logged in user roles
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)

    this.setState({logged_in_user_role});


    if (customerId && currentTab === 0 && !isBackClick) {
      this.setState({loader: true})
      // this.props.getLeadById(customerId); //get lead customer data
      this.setState({isLeadDetail: true});
    }

    const basicDetail = JSON.parse(sessionStorage.getItem('basicDetail'));
    this.setState({
      zipcode: basicDetail?.zipcode || '',
      firstName: basicDetail?.firstName,
      lastName: basicDetail?.lastName,
      address: basicDetail?.address,
      phone_numbers: basicDetail?.phone_numbers,
      emails: basicDetail?.emails?.length > 0 ? basicDetail?.emails : [{email: basicDetail?.leadData?.email, primary: true}],
      authorizedUser: basicDetail?.authorized_user,
      hear_about_us: basicDetail?.hear_about_us,
      outreach: basicDetail?.outreach,
      field_office_uuid: basicDetail?.field_office_uuid
    }, () => {
      if(!this.state.emails && this.state.emails.length === 0 ){
        this.genarateGibberrishEmail(); 
      }
    })
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.setState({loader: false});

    // Check zipcode
    if (nextProps?.zipcodeCheck && Object.keys(nextProps?.zipcodeCheck?.data).length > 0 && 
      nextProps?.zipcodeCheck?.data?.results?.length > 0) {
      this.setState({
        zipcodeCheck: true,
        franchises: nextProps?.zipcodeCheck?.data?.results,
        field_office_uuid: nextProps?.zipcodeCheck?.data?.results[0].uuid,
        errors: {}}, () => {
      });
    }

    // get lead customer data
    if (nextProps?.lead && (Object.keys(nextProps?.lead?.getLead).length > 0 || Object.keys(nextProps?.lead?.updateLead).length > 0)) {
      const basicDetail = JSON.parse(sessionStorage.getItem('basicDetail'));
      const leadData = Object.keys(nextProps?.lead?.getLead).length > 0 ? nextProps.lead.getLead : Object.keys(nextProps?.lead?.updateLead).length > 0 ? nextProps.lead.updateLead : null;

      if ((this.props.changeInfo && !this.state.isLocalValueChanged) || this.state.isLeadDetail) {

        let zipcode =  "";
        if (this.state.zipcode && this.state.zipcode !== basicDetail?.zipcode)
        {
          zipcode = this.state.zipcode
        }
        else if (basicDetail?.zipcode)
        {
          zipcode = basicDetail?.zipcode;
        }
        else if(leadData?.zip_code)
        {
          zipcode = leadData?.zip_code;
        }
        else if(leadData.field_office_uuid && leadData.field_office_uuid.addressable_zip_codes)
        {
          zipcode = leadData.field_office_uuid.addressable_zip_codes?.[0];
        }

        let haveAddressOnState = this.state?.address && this.state?.address?.address && this.state?.address?.city && this.state?.address?.state && this.state?.address?.zip_code ? true : false;

        this.checkZipcode(zipcode);
        this.setState({
          leadData, 
          firstName: !this.state.firstName && !basicDetail?.firstName ? `${leadData?.first_name}` : this.state.firstName ? this.state.firstName : basicDetail?.firstName, 
          lastName: !this.state.lastName && !basicDetail?.lastName ? `${leadData?.last_name}` : this.state.lastName ? this.state.lastName : basicDetail?.lastName,
          address: !haveAddressOnState && !basicDetail?.address ? leadData?.address?.[0] : haveAddressOnState ? this.state.address : basicDetail?.address,
          emails: leadData?.emailaddress_set?.length > 0 ? leadData?.emailaddress_set : [{email: leadData?.email, primary: true}],
          phone_numbers: leadData?.phone_numbers || [],
          authorizedUser: leadData?.authorizedUser || [],
          hear_about_us: leadData?.hear_about_us || [],
          zipcode,
          isLocalValueChanged: false,
          isLeadDetail: false,
          outreach : leadData?.outreach || '',
          field_office_uuid: !this.state.field_office_uuid && !basicDetail?.field_office_uuid ? leadData?.field_office?.uuid : this.state.field_office_uuid ? !this.state.field_office_uuid : basicDetail?.field_office_uuid
        }, () => {
          /**
           * AUTHOR: RITESH SOLANKI
           * <DP-3391>Leads Details | First Name and Last Name is not carry forwarded to billing page</DP-3391>
           * Changed: 08-11-2021 8:20 PM (Monday)
           */
          // const {address} = this.state;
          // console.warn('address - 1', address, this.refs["address"]);
          // if (this.refs["address"]) {
          //   let addressStr = address?.address ? `${address?.address}` : '';
          //   addressStr += address?.city ? `, ${address?.city}` : '';
          //   addressStr += address?.state ? `, ${address?.state}` : '';
          //   addressStr += address?.zip_code ? `, ${address?.zip_code}` : '';
          //   this.refs["address"].value = addressStr
          // }

          // if (zipcodeCheck) {
          //   if (zipcode && zipcode !== address?.zip_code) {
          //     // message.destroy()
          //     message.error('Please enter valid address')
          //   }
          // }
        });
      }
    }
    
    // get geocode
    if (Object.keys(nextProps?.GoogleApi?.getGeocode) && JSON.stringify(nextProps?.GoogleApi?.getGeocode) !== JSON.stringify(this.props?.GoogleApi?.getGeocode)) {
      this.setAddress(nextProps?.GoogleApi?.getGeocode)
    }
  }

  genarateGibberrishEmail = () => {
    let newEmail = [{email: '', primary: true}]
    newEmail[0].email = this.create_UUID() + '@doody.com'
    this.setState({emails:newEmail,is_dummy_email:true});  
  }

  create_UUID = () => {
    let dt = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = (dt + (Math.random()*16))%16 | 0;
      dt = Math.floor(dt/16);
      return (c==='x' ? r :(r&(0x3|0x8))).toString(16);
    });
    return uuid;
  }

  // Google Map Place API
  handleScriptLoad = () => {

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };

  // set address
  setAddress = (addressObject) => {
    const {address} = this.state;
    if (!isEmpty(addressObject)) {
      if (addressObject?.status === "OK") {
        let obj = {}, components = addressObject?.results?.[0];
        map(components?.address_components, (item) => {
          if (item?.types?.includes('administrative_area_level_2')) {
            obj = Object.assign(obj, { 'address': item.short_name })
          }
          if (item?.types?.includes('route')) {
            obj = Object.assign(obj, { 'route': item.short_name })
          }
          if (item?.types?.includes('street_number')) {
            obj = Object.assign(obj, { 'street_number': item.short_name })
          }
          if (item?.types?.includes('administrative_area_level_1')) {
            obj = Object.assign(obj, { 'state': item.short_name })
          }
          if (item?.types?.includes('locality')) {
            obj = Object.assign(obj, { 'city': item.long_name })
          }
          if (item?.types?.includes('postal_code')) {
            obj = Object.assign(obj, { 'zip_code': item.short_name })
          }
        });
        this.setState({address: {...address, ...obj}}, () => {
          //if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code || (zipcodeCheck && obj.zip_code !== this.state.zipcode)) {
          if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
            message.error('Please enter valid address');
          }
          this.setState({isLocalValueChanged: true})
        });

      } else {
        message.error('Something went wrong while getting address')
      }
    }
  }
  removeEmpty=(obj) =>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
  }
  // on start place change
  handlePlaceSelect = () => {
    const address= document?.getElementById('google_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: this.removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const addressObject = res?.data?.results[0];
      let obj = {};
      map(addressObject?.address_components, (item) => {

        if (item?.types?.includes('administrative_area_level_2')) {
          obj = Object.assign(obj, { 'address': item.short_name })
        }
        if (item?.types?.includes('route')) {
          obj = Object.assign(obj, { 'route': item.long_name })
        }
        if (item?.types?.includes('street_number')) {
          obj = Object.assign(obj, { 'street_number': item.short_name })
        }
        if (item?.types?.includes('administrative_area_level_1')) {
          obj = Object.assign(obj, { 'state': item.short_name })
        }
        if (item?.types?.includes('locality')) {
          obj = Object.assign(obj, { 'city': item.long_name })
        }
        if (item?.types?.includes('postal_code')) {
          obj = Object.assign(obj, { 'zip_code': item.short_name })
        }
      });
      obj.address=`${obj?.street_number || ''} ${obj?.route || ''}`;
      this.setState({address: {...address, ...obj}}, () => {
        if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
          message.error('Please enter valid address');
        }
        this.setState({isLocalValueChanged: true})
      });
    }).catch((err) => {
      console.log(err)
    })
  }

  // on service detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value }, () => this.setState({isLocalValueChanged: true}));
  }

  //on change
  onChange = (row, name) => {
    const {phone_numbers, emails, authorizedUser} = this.state;
    let data = name === 'phone' ? phone_numbers : name === 'email' ? emails : authorizedUser;
    if (name === 'phone' && phone_numbers[row]?.uuid) this.props.deletePhoneNumber(phone_numbers[row]?.uuid)
    data.splice(row, 1);
    if (name === 'phone' || name === 'email') {
      const idx = data?.findIndex(x => x.primary)
      if (idx <= -1 && !isEmpty(data)) data[0].primary = true
    }
    this.setState({[name === 'phone' ? 'phone_numbers' : name === 'email' ? 'emails' : 'authorizedUser']: data}, () => this.setState({isLocalValueChanged: true}));
    if(name === 'email'){
      if(data.length === 0){
        this.genarateGibberrishEmail()
      }
    }
  };

  //on add
  onAdd = (name) => {
    const {phone_numbers = [], emails = [], authorizedUser = [], user_name, phone, can_send_sms, phone_type, email , leadData} = this.state;
    if (name === 'phone') {
      phone_numbers.push({phone: phone, can_send_sms, primary: phone_numbers?.length === 0, type: phone_type });
      this.setState({phone_numbers}, () => {this.setState({isLocalValueChanged: true, phone: '', phone_type: 'mobile', can_send_sms: false})});
    } else if (name === 'email') {
      let NewEmails = emails && emails.length && emails.filter(email => {
        return !email.email.includes('doody.com');
      });
      NewEmails.push({email, primary: NewEmails?.length === 0});
      Object.assign(leadData, { 'is_dummy_email': false })
      this.setState({emails:NewEmails,leadData}, () => {this.setState({isLocalValueChanged: true, email: ''})});
    } else {
      authorizedUser.push({user_name, created_at: moment().format('MM/DD/YYYY')});
      this.setState({authorizedUser}, () => {this.setState({isLocalValueChanged: true, user_name: ''})});
    }
  };

  // on clear
  onClear = () => {
    this.setState({phone: '', email: '', user_name: ''});
  };

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on primary phone number changed
  onPhonePrimaryChanged = (index) => {
    const {phone_numbers} = this.state;
    map(phone_numbers, (obj) => obj.primary = false)
    phone_numbers[index].primary = true
    this.setState({phone_numbers}, () => this.setState({isLocalValueChanged: true}))
  }
  
  // on primary phone number changed
  onEmailPrimaryChanged = (index) => {
    const {emails} = this.state;
    map(emails, (obj) => obj.primary = false)
    emails[index].primary = true
    this.setState({emails}, () => this.setState({isLocalValueChanged: true}))
  }

  // check for logged in user zipcode
  checkedLoggedInUserZipcode = (zipCode) => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    if (!isEmpty(authUser) && authUser.user.zip_codes) {
      let temp = authUser.user.field_offices.find(item => item.addressable_zip_codes.includes(zipCode));

      if(temp?.uuid)
      {
        this.setState({
          field_office_uuid: temp.uuid,
          franchises: [temp]
        });
        
        return true;
      }
      else 
        return false;
    }
    return false
  }

  // on zip code changed
  onZipcodeChange = (e) => {
    this.setState({zipcode: e.target.value, isLocalValueChanged: true}, () => {
      const {zipcode} = this.state;
      
      if (zipcode.length === 5) {
        
        this.setState({loader: true});
        const {is_franchise_owner} = this.getLoggedInUserRole();
        const checkedZipcode = this.checkedLoggedInUserZipcode(zipcode);

        if(is_franchise_owner)
        {
          if (checkedZipcode) {
            this.props.checkZipCode({addressable_zip_codes__contains: zipcode, close: false}) // check zip code)
          } else {
            this.setState({zipcodeCheck: false}, () => this.props.resetCheckZipcode());
          }
        }
        else
        {
          this.props.checkZipCode({addressable_zip_codes__contains: zipcode, close: false});
        }
      } else {
        this.setState({zipcodeCheck: false}, () => this.props.resetCheckZipcode());
      }
    });
  };

  // get franchise for zipcode
  checkZipcode = (value) => {
    if (value && value !== this.state.zipcode) {
      this.setState({loader: true});
      this.props.checkZipCode({addressable_zip_codes__contains: value, close: false}); // check zip code
    }
  }

   // get logged in user
   getLoggedInUserRole = () => {
     const {logged_in_user_role} = this.state;

     let authUser = JSON.parse(localStorage.getItem('authUser'))
     const is_franchise_owner = logged_in_user_role?.includes('franchise_owner')
     const is_account_franchise = logged_in_user_role?.includes('accounting_franchiese')
     const is_ope_mgr_franchise = logged_in_user_role?.includes('operations_mgr')
     const is_buss_dev_franchise = logged_in_user_role?.includes('business_dev_franchiese')
     const franchise_uuid = authUser?.user?.associated_field_offices?.map(x => x.uuid);
     return {is_franchise_owner, franchise_uuid: franchise_uuid?.[0], is_disable_franchise_dropdown: (is_franchise_owner || is_ope_mgr_franchise || is_account_franchise || is_buss_dev_franchise)}
   }


  // format phone number
  formatPhoneNumber = (phone) => {
    if (!phone) return ''
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  // on address change
  onAddressChange = (e) => {
    const {address} = this.state;
    Object.assign(address, {[e.target.name]: e.target.value})
    this.setState({address});
  };

  // store data in local storage
  storeInLocal = () => {
    const google_address = this.refs['address'].value || '';
    const {
      phone_numbers,
      emails,
      firstName,
      lastName,
      address,
      zipcode,
      leadData,
      authorizedUser,
      zipcodeCheck,
      is_address_manually,
      hear_about_us,
      outreach,
      field_office_uuid,
    } = this.state;

    sessionStorage.setItem('basicDetail', JSON.stringify({
      leadData,
      firstName,
      lastName,
      address,
      phone_numbers,
      emails,
      authorizedUser,
      zipcode,
      zipcodeCheck,
      is_address_manually,
      google_address,
      hear_about_us,
      outreach,
      field_office_uuid
    }));
  }

  // validate required fields
  validate = () => {
    const {phone_numbers,emails, firstName, lastName, address, zipcodeCheck, zipcode} = this.state;

    const schema = yup.object().shape({
      zipcode: yup.string().required('Zipcode is required'),
      zipcodeCheck: yup.bool(),
      firstName: yup.string().required('Name is required'),
      lastName: yup.string().required('Name is required'),
      address: yup.object().shape({
        address: yup.string().required('address is required.'),
        city: yup.string().required('city is required.'),
        state: yup.string().required('state is required.'),
        zip_code: yup.string().test('match', 'zip code is required.', (zip_code) => {
          if (zipcodeCheck) return zip_code //=== zipcode
          return true
        }),
      }),
      phone_numbers: yup.array(yup.object({
        phone: yup.string().required('Phone is required')
      })).required("Phone number required"),
      emails: yup.array(yup.object({
        email: yup.string().required('Email is required')
      })).required("Email Address required"),
    });

    const data = {
      zipcode,
      zipcodeCheck,
      firstName, 
      lastName,
      address,
      phone_numbers,
      emails,
    };

    return schema.validate(data, { abortEarly: false }).then(() => {
      this.setState({isBasicDetail: true, errors: {}}, () => {
        this.props.validateBasicInfo(true);
        this.storeInLocal();
      });
      return Promise.resolve('success')
    }).catch((error) => {
      let err_data = {};
      map(error?.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data, isBasicDetail: false}, () => {
        this.props.validateBasicInfo(false);
        this.storeInLocal();
      });
      return Promise.reject('fail')
    });
  };

  // render all state
  renderAllState = () => {
    return AllState.AllState.map((item, i) => {
      return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    });
  }

  // render phone numbers
  renderPhoneNumbers = () => {
    const {phone_numbers, phone, phone_type, can_send_sms, errors, zipcodeCheck} = this.state;
    return (
      <div>
        <h5 className=" mt-30">Phone Numbers</h5>
        <div className="inline-check-list gcheck">
          {
            map(phone_numbers, (item, index) => <div className="fitem-check" key={`phoneNumber${index}`}>
              <input type="radio" className="fitem-ck-input" id={`checkboxPhone${index}`} name={`checkboxPhone${index}`} checked={item?.primary}
                onChange={() => this.onPhonePrimaryChanged(index)} />
              <label htmlFor={`checkboxPhone${index}`} className="fitem-ck-txt black">{`+1 ${this.formatPhoneNumber(item?.phone)} ${item?.primary ? '(Primary)' : ''}`}</label>
              <a className="red float-right" href="/#" onClick={(e) => {e.preventDefault(); this.onChange(index, 'phone')}}><u>Remove</u></a>
            </div>)
          }
        </div>
        <div className="fitem fitem-rinner mt-10 flex">
          <input name="phone" type="text" placeholder="Add New Phone Number" value={phone} maxLength={"10"} disabled={!zipcodeCheck}
            max={"10"} onChange={(e) => this.onNumericInputChange(e.target.value) && this.onTextChange(e)}/>
          <Select
            onChange={(e) => this.onTextChange({target: {name: 'phone_type', value: e}}) }
            style={{marginLeft: "8px", marginRight: "8px"}}
            name="phone_type"
            value={phone_type}
            placeholder="Type">
            <Option value="home_phone">Home</Option>
            <Option value="mobile">Mobile</Option>
          </Select>
          <button className={`btn ${phone.length !== 10 ? 'disabled' : 'btn-warning'}`}
            disabled={phone.length !== 10} onClick={() => this.onAdd('phone')}><PlusOutlined /></button>
        </div>
        {phone_type === 'mobile' ? <div className="fitem-check">
          <input
            type="checkbox"
            className="fitem-ck-input"
            id={`can_send_sms`}
            onChange={(e) => this.onTextChange(e, 'bool')}
            checked={can_send_sms}
            name="can_send_sms" />
          <label htmlFor={`can_send_sms`} className="fitem-ck-txt">{`Send SMS updates about my service to this number.`}</label>
        </div> : ''}
        {errors?.[`phone_numbers`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[`phone_numbers`]}</label> : ''}
      </div>
    )
  }

  // render email addresses
  renderEmails = () => {
    const {emails, email, errors, leadData} = this.state;
    return (
      <div>
        <h5 className=" mt-30">Email Addresses</h5>
        <div className="inline-check-list gcheck">
          {map(emails, (item, index) => (item?.email && !leadData?.is_dummy_email && !item.email.includes('doody.com')) ? <div className="fitem-check" key={`email${index}`}>
            <input type="checkbox" className="fitem-ck-input" id={`checkboxEmail${index}`} name={`checkboxEmail${index}`} checked={item?.primary}
              onChange={() => this.onEmailPrimaryChanged(index)}/>
            <label htmlFor={`checkboxEmail${index}`} className="fitem-ck-txt black">{`${item?.email} ${item?.primary ? '(Primary)' : ''}`}</label>
            <a className="red float-right" href="/#" onClick={(e) => {e.preventDefault(); this.onChange(index, 'email')}}><u>Remove</u></a>
          </div> : ''
          )}
        </div>
        <div className="fitem fitem-rinner mt-10">
          <input 
            name="email"
            type="text"
            value={email}
            placeholder="Add New Email Address"
            onChange={(e) => this.onTextChange(e)}
          />
          <button
            className={`btn fitem-ricon ${!REGULAR_EXPRESSION_EMAIL.test(email) ? 'disabled' : 'btn-warning'}`}
            disabled={!REGULAR_EXPRESSION_EMAIL.test(email)}
            onClick={() => this.onAdd('email')}
          >
            <PlusOutlined />
          </button>
        </div>
        {errors?.[`emails`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[`emails`]}</label> : ''}
      </div>
    )
  };

    // on service detail change
    onTextChangeSource = (e, type) => {
      console.log("************",e.target.value,type)
      const value = type === 'bool' ? e.target.checked : e.target.value;
      //this.setState({hear_about_us: e.target.value})
      this.setState({ [e.target.name]: [value] }, () => this.setState({isLocalValueChanged: true}))
    }
    
  // render Lead source
  renderLeadSource = () => {
    const {hear_about_us} = this.state;
    return (
      <div>
        <h5 className=" mt-30">How did you hear about us</h5>
        <div className="inline-check-list gcheck">
          <Select
            name="hear_about_us"
            value={hear_about_us}
            placeholder="Select the source"
            onChange={(e) => this.onTextChangeSource({ target: { name: 'hear_about_us', value: e } })}
          >
            {aboutUsData?.map((item) => (
              <Option id={item.id} value={item.value} key={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>

        </div>
      </div>
    )
  };

  // render authorized proposal
  renderAuthorizedUsers = () => {
    const {authorizedUser, user_name, zipcodeCheck} = this.state;
    return (
      <div>
        <h5 className=" mt-30">Authorized Users</h5>
        <div className="inline-check-list gcheck">
          {map(authorizedUser, (item, index) => <div className="fitem-check flex" key={`user${index}`}>
            <b className="d-block">{item?.user_name}</b>
            <div className="flex">
              <span className="mr-2">{`Added ${moment(item?.created_at)?.format('MM/DD/YYYY')}`}</span>
              <a className="red" href={'/#'} onClick={(e) => {e.preventDefault(); this.onChange(index, 'authorizedUser')}}><u>Remove</u></a>
            </div>
          </div>
          )}
        </div>
        <div className="fitem fitem-rinner mt-10">
          <input name="user_name" type="text" placeholder="Add New Authorized User" value={user_name} disabled={!zipcodeCheck}
            onChange={(e) => this.onTextChange(e)}/>
          <button className={`btn fitem-ricon ${!user_name ? 'disabled' : 'btn-warning'}`}
            disabled={!user_name} onClick={() => this.onAdd('authorizedUser')}><PlusOutlined /></button>
        </div>
      </div>
    )
  }
  
  render() {
    const {zipcodeCheck, zipcode, franchises, firstName, lastName, address, errors, loader, is_address_manually } = this.state;
    const franchiseName = franchises?.map((obj) => obj?.name) || [];
    let addressStr = address?.address ? `${address?.address}` : '';
    addressStr += address?.city ? `, ${address?.city}` : '';
    addressStr += address?.state ? `, ${address?.state}` : '';
    addressStr += address?.zip_code ? `, ${address?.zip_code}` : '';
    if (this.refs["address"]) {
      this.refs["address"].value = addressStr;
    }

    return (
      <div className="aleft">
        {loader && <Loader />}
        <h4>Do we service this area?</h4>
        <p>If you are here, this is for a new customer calling right now. First of all, take their zipcode for their service address to make sure we service this area.</p>
        <div className="form-group">
          <div className="fitem">
            <label>Service Zipcode</label>
            <input
              type="text"
              placeholder="Zipcode"
              name="zipcode"
              max={5}
              maxLength={5}
              value={zipcode || ''}
              onChange={(e) => this.onZipcodeChange(e)}
            />
            {errors?.['zipcode'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['zipcode']}</label> : ''}
          </div>
          {zipcode ? zipcodeCheck ? <div className="greenbox mb-30">
            <b className="d-block">We cover this area.</b>
            <b className="d-block">{`This is under the ${franchiseName?.toString()} Franchise.`}</b>
          </div> :
            <div className="dangerbox mb-30">
              <b className="d-block">We don’t currently have any franchises covering this area. Save their email to notify them if we move into this area. </b>
            </div> : ''}
        </div>
        <div className="form-group">
          <h4>Contact Information</h4>
          {zipcodeCheck && <div className="fitem half-fitem">
            <div className="fitem half-fitem">
              <label>First Name</label>
              <input type="text" placeholder="First Name" name="firstName" value={firstName} onChange={(e) => this.onTextChange(e)} />
              {errors['firstName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['firstName']}</label> : ''}
            </div>
            <div className="fitem half-fitem">
              <label>Last Name</label>
              <input type="text" placeholder="Last Name" name="lastName" value={lastName} onChange={(e) => this.onTextChange(e)} />
              {errors['lastName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['lastName']}</label> : ''}
            </div>
          </div>}
          {zipcodeCheck && <div className="google_search_place fitem">
            <label>Address (Service)</label>
            <Script
              url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
              onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}
            />

            <input
              autoComplete="off"
              type="text"
              ref="address"
              disabled={(!zipcodeCheck || is_address_manually)}
              className={'form-control mb-10'}
              placeholder={addressStr ? addressStr : "Location"}
              name="google_address"
              id="google_address"
              onChange={(e) => {
                if (!e.target.value) {
                  this.setState({
                    address: { address: '', state: '', city: '', zip_code: '' }
                  })
                }
              }}
            />
            <b>or <a href="/" onClick={(e) => {
              e.preventDefault();
              this.setState({
                is_address_manually: true,
                address: {address: '', city: '', state: '', zip_code: ''},
              }, () => {
                if (this.refs['address']) {
                  this.refs['address'].value = '';
                } })
            }}><u>enter address manually</u></a></b>
          </div>}
          {
            is_address_manually &&
            <div className="manually_address">
              <a href="/#" onClick={(e) => {
                e.preventDefault();
                this.setState({
                  is_address_manually: false,
                  address: {address: '', city: '', state: '', zip_code: ''},
                })
              }}><img src={cross_icon} alt="" className="float-right mb-10" /></a>
              <br />

              <div className="form-group mb-20">
                <div className="fitem">
                  <input
                    type="text"
                    placeholder="Address"
                    name="address"
                    value={address?.address}
                    onChange={(e) => this.onAddressChange(e)}
                  />
                </div>
                <div className="half-fitem fitem">
                  <div className="half-fitem fitem">
                    <input
                      type="text"
                      placeholder="City"
                      name="city"
                      value={address?.city}
                      onChange={(e) => this.onAddressChange(e)}
                    />
                  </div>
                  <div className="half-fitem fitem">
                    <Select
                      showArrow={true}
                      name="state"
                      placeholder="State"
                      onChange={(value) => this.onAddressChange({ target: { name: 'state', value: value } })}
                      value={address?.state || undefined}
                      virtual={false}
                    >
                      {this.renderAllState()}
                    </Select>
                  </div>
                  <div className="half-fitem fitem">
                    <input
                      type="text"
                      className='form--control'
                      placeholder="ZIP Code"
                      name="zip_code"
                      maxLength={5}
                      minLength={5}
                      onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChange(e)}
                      value={address?.zip_code || ''}
                    />
                  </div>
                </div>
              </div>
            </div>
          }
          {(errors?.['address.address'] || errors?.['address.city'] || errors?.['address.state'] || errors?.['address.zip_code'])
            ? <label className="new_err_msg"><i className="las la-info-circle"/>{'Please enter valid address'}</label> : ''}
        </div>
        {zipcodeCheck ? this.renderPhoneNumbers() : ''}
        {this.renderEmails()}
        {zipcodeCheck ? this.renderAuthorizedUsers() : ''}
        {this.renderLeadSource()}
      </div>
    )
  }
}

export default BasicDetail;